/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/16/21
 */

import React from "react";
import {Stack, useTheme} from "@mui/material";
import {borderedSx, fixedSx, footerFixedSx, contentSx, lastOfTypeY} from "./sx";
import CapacityCell from "./CapacityCell";
import {useSelector} from "react-redux";
import {State} from "../state/store";
import {addMinutes, areIntervalsOverlapping} from "date-fns";
import { VegaEvent, Employee, GoogleEvent, Holiday, WorkdayEvent, OpsGenieEvent } from "../interfaces/Global";

export interface FooterProps {
	intervals: Date[]
	employees: Employee[]
	vegaEvents: VegaEvent[]
	googleEvents: GoogleEvent[]
	workdayEvents: WorkdayEvent[]
	opsGenieEvents: OpsGenieEvent[]
	oooEvents: Record<string, Interval[]>
	holidays: Holiday[]
	intervalWidth: number
	intervalDuration: number
	capacityCalculateResolution: number
}

export default function Footer(props: FooterProps) {

	const capacity = useSelector((s:State) => s.settings.capacity);
	const theme = useTheme();

	if (capacity === "off") {
		return null;
	}

	return (
		<Stack direction={"row"} sx={contentSx}>
			<Stack sx={{ ...fixedSx(theme), ...borderedSx(theme), ...footerFixedSx }}/>
			<Stack direction={"row"} sx={{ height: "100%", ...lastOfTypeY(theme) }}>
				{props.intervals.map(d =>
					<CapacityCell
						key={d.toISOString()}
						interval={{ start: d, end: addMinutes(d, props.intervalDuration) }}
						employees={props.employees}
						vegaEvents={props.vegaEvents.filter(e => areIntervalsOverlapping(
							{ start: d, end: addMinutes(d, props.intervalDuration) },
							{ start: e.startDatetime, end: e.endDatetime }
						))}
						googleEvents={props.googleEvents.filter(e => areIntervalsOverlapping(
							{ start: d, end: addMinutes(d, props.intervalDuration) },
							{ start: e.startDatetime, end: e.endDatetime }
						))}
						workdayEvents={props.workdayEvents.filter(e => areIntervalsOverlapping(
							{ start: d, end: addMinutes(d, props.intervalDuration) },
							{ start: e.startDatetime, end: e.endDatetime }
						))}
						opsGenieEvents={props.opsGenieEvents.filter(e => areIntervalsOverlapping(
							{ start: d, end: addMinutes(d, props.intervalDuration) },
							{ start: e.startDatetime, end: e.endDatetime }
						))}
						oooEvents={props.oooEvents}
						holidays={props.holidays.filter(h => areIntervalsOverlapping(
							{ start: d, end: addMinutes(d, props.intervalDuration) },
							{ start: h.startDate, end: h.endDate }
						))}
						c1={props.capacityCalculateResolution}
						width={props.intervalWidth}
					/>
				)}
			</Stack>
		</Stack>
	);

}